import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

export const StyledSearchResultsContainer = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(4),
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
        gap: theme.spacing(2),
    },
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        gridTemplateColumns: "repeat(2, 1fr)",
    },
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
}));

export const StyledPaginationContainer = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const Spacer = styled("div")(({ theme }) => ({
    height: theme.spacing(1),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
}));
